// Bundled default assets, referenced from the default page via "asset:<key>".
import home_main from '../assets/home.png';
import homebg from '../assets/homebg.png';
import code from '../assets/code.png';
import swipe_left from '../assets/swipe-left.png';
import info from '../assets/info.png';
import aim from '../assets/aim.png';
import idea from '../assets/idea.png';
import training from '../assets/training.png';
import su from '../assets/su.png';
import hu from '../assets/hu.png';
import jin from '../assets/jin.png';
import feng from '../assets/feng.png';
import yang from '../assets/yang.png';
import zhou from '../assets/zhou.png';
import hui from '../assets/hui.png';
import modernization from '../assets/modernization.png';
import img1 from '../assets/img.png';
import img2 from '../assets/img2.png';
import high_five from '../assets/high-five.png';
import career from '../assets/career.png';
import mcma from '../assets/mcma.png';
import mlvk from '../assets/mlvk.png';
import mly from '../assets/mly.png';
import mqa from '../assets/mqa.png';
import contact_mail from '../assets/contact-mail.png';
import logo from '../assets/logo.png';
import instagram from '../assets/instagram.png';
import facebook from '../assets/facebook.png';

export const ASSETS = {
  home_main,
  homebg,
  code,
  swipe_left,
  info,
  aim,
  idea,
  training,
  su,
  hu,
  jin,
  feng,
  yang,
  zhou,
  hui,
  modernization,
  img1,
  img2,
  high_five,
  career,
  mcma,
  mlvk,
  mly,
  mqa,
  contact_mail,
  logo,
  instagram,
  facebook,
};

// Resolve a block URL: "asset:<key>" -> bundled import, otherwise as-is.
export function resolveUrl(url) {
  if (typeof url === 'string' && url.startsWith('asset:')) {
    return ASSETS[url.slice(6)] || url;
  }
  return url;
}
